import dynamic from "next/dynamic";

import { useI18n } from "utils/with-i18n.utils";

import animation from "./data-fr-us.json";

const Lottie = dynamic(() => import("react-lottie-player"));

export const Plane = () => {
  const i18n = useI18n();

  return (
    <div className="flex  flex-col gap-6 mx-auto md:w-2/3">
      <div className="flex items-center self-center p-2.5 w-fit bg-pastel-green-2">
        <span className="text-lg leading-[20.5px] text-black md:text-2xl">
          {i18n.t("environment.co2.equivalence")}
        </span>
      </div>
      <div className="flex justify-center items-center w-full">
        <Lottie animationData={animation} loop play />
      </div>
      <div className="text-center">
        <span className="leading:[36px] text-[50px] font-black whitespace-nowrap lg:text-[100px] lg:leading-[72px]">
          {i18n.t("environment.co2.flight")}
        </span>
        <p className="leading:[36px] text-base lg:text-2xl lg:leading-[72px]">
          {i18n.t("environment.co2.ar", {}, { html: true })}
        </p>
      </div>
    </div>
  );
};
